import NoteIcon from "@mui/icons-material/Note";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import PeopleIcon from "@mui/icons-material/People";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import MenuSharpIcon from "@mui/icons-material/MenuSharp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExploreIcon from "@mui/icons-material/Explore";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PaymentIcon from "@mui/icons-material/Payment";
import ChatIcon from "@mui/icons-material/Chat";
import PersonIcon from "@mui/icons-material/Person";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ShareIcon from "@mui/icons-material/Share";
import {
  Dashboard as DashboardIcon,
  Assignment as RequirementIcon,
  Settings,
} from "@mui/icons-material";
import BarChartIcon from "@mui/icons-material/BarChart";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import AssessmentIcon from "@mui/icons-material/Assessment";
import HistoryIcon from "@mui/icons-material/History";
import GetAppIcon from "@mui/icons-material/GetApp";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import ForumIcon from "@mui/icons-material/Forum";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import NotificationsIcon from "@mui/icons-material/Notifications";
const sidebar = {
  fp: [
    {
      name: "Dashboard",
      icon: <DashboardIcon />,
      link: "/finance-partner/dashboard",
    },
    {
      name: "Payment & Financing Instruments",
      path: "/finance-partner/rfq",
      icon: <ExploreIcon />,
    },
  ],
};

export default sidebar;
